<div class="tree-item">
	@if (expanded) {
		<mat-icon class="expand-icon" [ngClass]="childrenGroups.length !== 0 || childrenUsers.length !== 0 ? 'icon-display' : 'icon-hidden'" (click)="onExpand()">remove</mat-icon>
	} @else {
		<mat-icon class="expand-icon" [ngClass]="childrenGroups.length !== 0 || childrenUsers.length !== 0 ? 'icon-display' : 'icon-hidden'" (click)="onExpand()">add</mat-icon>
	}
	<div class="tree-item-value">
		<table>
			@if (!isDisplayUser) {
				<tr class="nodeHeader">
					<td class="nodeName">
						<span>{{ group.name }}</span>
					</td>
					<td class="nodeAction">
						<mat-icon id="menuIcon" class="menu-icon" (click)="displayContextualMenu($event, group); $event.preventDefault()">more_vert</mat-icon>
					</td>
				</tr>
			} @else {
				<tr class="nodeHeader">
					<td class="nodeName" colspan="2">
						<span>{{ group.name }}</span>
					</td>
				</tr>
			}
			<tr class="node">
				<td class="nodeInfo" colspan="2">
					@if (isIdVisible === true) {
						<span>id&nbsp;:&nbsp;{{ group.id }}</span>
					}
					@if (!!roleName) {
						<span>role&nbsp;:&nbsp;{{ roleName }}</span>
					}
				</td>
			</tr>
		</table>
	</div>
</div>

@if (expanded) {
	<div class="tree-item-children">
		@for (child of childrenGroups; track child) {
			<div class="tree-item-child">
				<app-group-tree-item
					[isDisplayUser]="isDisplayUser"
					[group]="child"
					[roles]="roles"
					[cultures]="cultures"
					[expanded]="false"
					(groupDisplayed)="onGroupDisplayed($event)"
					(groupEdited)="onGroupEdited($event)"
					(groupReseted)="onGroupReseted($event)"
					(userDisplayed)="onUserDisplayed($event)"
					(userEdited)="onUserEdited($event)"
					(userReseted)="onUserReseted($event)"></app-group-tree-item>
			</div>
		}
	</div>
	<div class="tree-item-children">
		@for (child of childrenUsers; track child) {
			<div class="tree-item-child">
				<app-user-tree-item
					[user]="child"
					[roles]="roles"
					[cultures]="cultures"
					(itemDisplayed)="onUserDisplayed($event)"
					(itemEdited)="onUserEdited($event)"
					(itemReseted)="onUserReseted($event)"></app-user-tree-item>
			</div>
		}
	</div>
}

<app-contextual-menu [items]="menuItems" direction="RIGHT" (menuChanged)="onMenuChanged($event)"></app-contextual-menu>
